import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  MatFormFieldModule,
  MatInputModule,
  MatDatepickerModule,
  MatSelectModule,
  MatButtonModule
} from '@angular/material';

import {TextFilterComponent} from './components/filter-controls/text-filter/text-filter.component';
import {NumberFilterComponent} from './components/filter-controls/number-filter/number-filter.component';
import {DateFilterComponent} from './components/filter-controls/date-filter/date-filter.component';
import {TimeFilterComponent} from './components/filter-controls/time-filter/time-filter.component';
import {EnumFilterComponent} from './components/filter-controls/enum-filter/enum-filter.component';
import {DaterangeFilterComponent} from './components/filter-controls/daterange-filter/daterange-filter.component';
import {BooleanFilterComponent} from './components/filter-controls/boolean-filter/boolean-filter.component';

import { FilterDashboardComponent } from './components/filter-dashboard/filter-dashboard.component';

import { FilterBuilderService } from './services/filter-builder.service';
import { NormalizedUnderscorePipe } from './pipes/normalized-underscore.pipe';


@NgModule({
  declarations: [
    TextFilterComponent,
    BooleanFilterComponent,
    DaterangeFilterComponent,
    DateFilterComponent,
    TimeFilterComponent,
    EnumFilterComponent,
    NumberFilterComponent,
    FilterDashboardComponent,
    NormalizedUnderscorePipe
  ],

  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
  ],

  providers: [FilterBuilderService],

  exports: [
    TextFilterComponent,
    BooleanFilterComponent,
    DaterangeFilterComponent,
    DateFilterComponent,
    TimeFilterComponent,
    EnumFilterComponent,
    NumberFilterComponent,
    FilterDashboardComponent
  ],

  entryComponents: [
    TextFilterComponent,
    BooleanFilterComponent,
    DaterangeFilterComponent,
    DateFilterComponent,
    TimeFilterComponent,
    EnumFilterComponent,
    NumberFilterComponent,
  ]
})

export class FilterModule { }
